import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { RevShareApiClientContext } from '../rev-share.context';
export const getProductRevshareAmountsQueryFn = async props => {
  var _purchaseUserOffering, _product$pricingDetai;
  const {
    httpClient,
    request
  } = props;
  const revShareApiClient = await import('../rev-share.api-client');
  const {
    getPurchaseUserOffering
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = RevShareApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to get product revshare amounts');
  }
  const purchaseUserOffering = await getPurchaseUserOffering({
    ...p3Context
  });
  const product = (_purchaseUserOffering = purchaseUserOffering.products) == null ? void 0 : _purchaseUserOffering.find(p => p.productId === request.productId);
  if (!product) {
    return {
      amounts: []
    };
  }
  const pricingDetails = ((_product$pricingDetai = product.pricingDetails) == null ? void 0 : _product$pricingDetai.filter(pricingDetail => {
    var _pricingDetail$finalP;
    return pricingDetail.cycle && ((_pricingDetail$finalP = pricingDetail.finalPrice) == null || (_pricingDetail$finalP = _pricingDetail$finalP.total) == null ? void 0 : _pricingDetail$finalP.amount);
  })) ?? [];
  const revShareAmountsPromises = pricingDetails.map(async pricingDetail => {
    var _pricingDetail$finalP2;
    const cycle = pricingDetail.cycle;
    const price = Number((_pricingDetail$finalP2 = pricingDetail.finalPrice) == null || (_pricingDetail$finalP2 = _pricingDetail$finalP2.total) == null ? void 0 : _pricingDetail$finalP2.amount);
    const revShareAmount = await revShareApiClient.RevShareApiClient.queries({
      httpClient
    }).getRevShareAmountByProductAndCycle({
      productId: request.productId,
      siteGuid: request.siteGuid,
      productTypeId: request.productTypeId,
      price,
      cycle
    });
    return {
      cycle,
      amount: revShareAmount.amount
    };
  }) ?? [];
  const revShareAmounts = (await Promise.all(revShareAmountsPromises)) ?? [];
  return {
    amounts: revShareAmounts
  };
};
//# sourceMappingURL=get-product-revshare-amounts.query.js.map